/**
 * 精选车辆推荐列表
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker, Row, Col, Switch, Select } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';

import DictSelect from '../../ui/DictSelect';

import validator from '../../../util/validator';
import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';

const fields = [{
    "text": "报告编号",
    "field": "valuationNo",
    "disabled": true
}, {
    "text": "评估日期",
    "field": "valuationDate",
    "date": true,
    rules: [
        { required: true, message: '评估日期不能为空!' },
    ]
}, {
    "text": "委托方名称",
    "field": "client",
    rules: [
        { required: true, message: '委托方名称不能为空!' },
        { max: 32, message: '委托方名称不能超过32个字符！' },
    ]
}, {
    "text": "委托方电话",
    "field": "clientTel",
    rules: [
        { required: true, message: '委托方电话不能为空!' },
        validator.tel
    ],
}, {
    "text": "车主名称",
    "field": "owner",
    rules: [
        { required: true, message: '车主名称不能为空!' },
        { max: 32, message: '车主名称不能超过32个字符！' },
    ]
}, {
    "text": "鉴定目的",
    "field": "purpose",
    "select": true,
    "category": "ASSESSMENET_PURPOSE",
    rules: [
        { required: true, message: '鉴定目的不能为空!' },
    ]
}, {
    "text": "登记证书编号",
    "field": "registerNo",
    rules: [
        { required: true, message: '登记证书编号不能为空！' },
        { max: 12, message: '登记证书编号为12位数字！' },
        { min: 12, message: '登记证书编号为12位数字！' },
        validator.num
    ]
}, {
    "text": "车架号",
    "field": "vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 32, message: '车架号不能超过32个字符！' },
        validator.enNum
    ]
}, {
    "text": "车牌号码",
    "field": "plateNo",
    rules: [
        { required: true, message: '车牌号码不能为空!' },
        validator.plateNo
    ]
}, {
    "text": "品牌型号",
    "field": "brandModel",
    rules: [
        { required: true, message: '品牌型号不能为空!' },
        { max: 64, message: '品牌型号不能超过64个字符！' },
    ]
}, {
    "text": "发动机号",
    "field": "engineNo",
    rules: [
        { required: true, message: '发动机号不能为空!' },
        { max: 64, message: '发动机号不能超过64个字符！' },
        validator.lineEnNum
    ]
}, {
    "text": "车身颜色",
    "field": "color",
    "category": "VEHICLE_COLOR",
    select: true,
    rules: [
        { required: true, message: '车身颜色不能为空!' },
    ]
}, {
    "text": "表里程数/万公里",
    "field": "mileage",
    number: true,
    rules: [
        { required: true, message: '表里程数不能为空!' },
    ]
}, {
    "text": "注册日期",
    "field": "registerDate",
    "date": true,
    rules: [
        { required: true, message: '注册日期不能为空!' },
    ]
}, {
    "text": "年审检验合格到期时间",
    "field": "examinationDate",
    "month": true,
}, {
    "text": "车船使用税截至日期",
    "field": "vehicleTaxProbationEndDate",
    "month": true,
    // rules: [
    //     { required: true, message: '车船使用税截至日期不能为空!' },
    // ]
}, {
    "text": "交强险截至日期",
    "field": "mandatoryInsuranceDate",
    "date": true,
    // rules: [
    //     { required: true, message: '交强险截至日期不能为空!' },
    // ]
}, {
    "text": "商业险截至日期",
    "field": "commerciaInsuranceDate",
    "date": true,
    // rules: [
    //     { required: true, message: '商业险截至日期不能为空!' },
    // ]
}, {
    "text": "是否查封、抵押车辆",
    "field": "mortgage",
    "radio": true,
}, {
    "text": "购置附加税（费）证",
    "field": "additionalTax",
    "radio": true,
}, {
    "text": "机动车登记证书",
    "field": "registerCertificate",
    "radio": true,
}, {
    "text": "机动车行驶证",
    "field": "vehicleLicense",
    "radio": true,
}, {
    "text": "未处理违法记录",
    "field": "violationRecord",
    "radio": true,
}, {
    "text": "使用性质",
    "field": "useProperty",
    "select": true,
    "category": "VEHICLE_USE_PROPERTY",
    rules: [
        { required: true, message: '使用性质不能为空!' },
    ]
}, {
    "text": "鉴定等级",
    "field": "resultGrade",
    "select": true,
    "category": "VEHICLE_CONDICTION_GRADE",
    rules: [
        { required: true, message: '鉴定等级不能为空!' },
    ]
}, {
    "text": "估值/元",
    "field": "valuationResult",
    "number": true,
    rules: [
        { required: true, message: '估值不能为空!' },
    ]
}, {
    "text": "评估师",
    "field": "assessorId",
    "assessor": true,
    rules: [
        { required: true, message: '评估师不能为空!' },
    ]
}, {
    "text": "复核人",
    "field": "reviewerId",
    "assessor": true,
    rules: [
        { required: true, message: '复核人不能为空!' },
    ]
}];


const textareaFields = [{
    "text": "技术状况",
    "field": "technicalCondition",
    "textarea": true,
    rules: [
        { required: true, message: '技术状况不能为空!' },
        { max: 256, message: '技术状况不能超过256个字符！' },
    ]
}, {
    "text": "重要配置及参数",
    "field": "importantConfig",
    "textarea": true,
    rules: [
        { required: true, message: '重要配置及参数不能为空!' },
        { max: 256, message: '重要配置及参数不能超过256个字符！' },
    ]
}, {
    "text": "特别事项说明",
    "field": "specialNotes",
    "textarea": true,
    rules: [
        { required: true, message: '特别事项说明不能为空!' },
        { max: 256, message: '特别事项说明不能超过256个字符！' },
    ]
}];

const image = [{
    text: '证件照正面',
    field: 'identityFrontImg'
}, {
    text: '证件照反面',
    field: 'identityBackImg'
}, {
    text: '机动车登记证首页',
    field: 'registration12Img'
}, {
    text: '机动车登记证尾页',
    field: 'registration34Img'
}, {
    text: '行驶证主页',
    field: 'licenseMainImg'
}, {
    text: '行驶证副页',
    field: 'licenseSubImg'
}, {
    text: '商业险保单图片',
    field: 'commerciaInsuranceImg'
}, {
    text: '交强险保单图片',
    field: 'mandatoryInsuranceImg'
}, {
    text: '公司营业执照或法人证书',
    field: 'corporationCertImg'
}, {
    text: '固定资产车辆清查明细',
    field: 'fixedAssetCertImg'
}, {
    text: '增值税专用发票开具明细',
    field: 'vatInvoiceImg'
}]

class VehicleRecommendEditForm extends Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
        assessors: [],  //评估师信息
    }

    componentDidMount() {
        http.get({
            url: "/valuationApply/findAssessor",
            success: (res) => {
                if (res == null) res = [];
                this.setState({ assessors: res });
            }
        });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            if (values["valuationDate"] != null) { //评估日期
                values["valuationDate"] = values["valuationDate"].format("YYYY-MM-DD");
            }
            if (values["examinationDate"] != null) {    //年审检验合格到期时间
                values["examinationDate"] = values["examinationDate"].format("YYYY-MM");
            }
            if (values["vehicleTaxProbationEndDate"] != null) { //车船税试用截至日期
                values["vehicleTaxProbationEndDate"] = values["vehicleTaxProbationEndDate"].format("YYYY-MM");
            }
            if (values["mandatoryInsuranceDate"] != null) { //评估日期
                values["mandatoryInsuranceDate"] = values["mandatoryInsuranceDate"].format("YYYY-MM-DD");
            }
            if (values["commerciaInsuranceDate"] != null) { //评估日期
                values["commerciaInsuranceDate"] = values["commerciaInsuranceDate"].format("YYYY-MM-DD");
            }
            if (values["registerDate"] != null) {
                values["registerDate"] = values["registerDate"].format("YYYY-MM-DD");
            }
            values["mortgage"] = values["mortgage"] ? 1 : 0;
            values["additionalTax"] = values["additionalTax"] ? 1 : 0;
            values["registerCertificate"] = values["registerCertificate"] ? 1 : 0;
            values["vehicleLicense"] = values["vehicleLicense"] ? 1 : 0;
            values["violationRecord"] = values["violationRecord"] ? 1 : 0;
            http.post({
                url: '/valuationApply/saveValuationInfo',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (item, index, colLength) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let labelCol = colLength === 1 ? 10 : 4;
        let wrapperCol = colLength === 1 ? 14 : 20;
        let itemDom = (
            <Form.Item key={index} label={item.text + "："} labelCol={{ span: labelCol }} wrapperCol={{ span: wrapperCol }}>
                {
                    getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                        : item.month ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                            : item.radio ? editData[item.field] === 1
                                : item.vehicle || item.assessor ? editData[item.field] == null ? "" : editData[item.field] + ""
                                    : editData[item.field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.number ?
                            <InputNumber precision={2} min={0} max={99999999} style={{ width: '100%' }} />
                            : item.select ?
                                <DictSelect category={item.category} />
                                : item.assessor ?
                                    <Select>{this.state.assessors.map(d => <Select.Option key={d["id"]}>{d["name"]}</Select.Option>)}</Select>
                                    : item.radio ?
                                        <Switch checkedChildren="是" unCheckedChildren="否" />
                                        : item.date ? <DatePicker style={{ width: '100%' }} placeholder="请选择日期" />
                                        : item.month ? <DatePicker.MonthPicker style={{ width: '100%' }} placeholder="请选择月份" />
                                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                : <Input disabled={item.disabled} />
                    )
                }
            </Form.Item>
        );
        return itemDom;
    };

    create2Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDom(data[i], "1" + i, 1)}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDom(data[i + 1], "1" + i, 1) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    }

    create1Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = this.createDom(data[i], "2" + i, 2);
            dom.push(item);
        }
        return dom;
    }

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        const imgsInfo = editData.image;
        for (let i = 0; i < field.length; i += 1) {
            let path = imgsInfo != null && imgsInfo[field[i]["field"]] ? "data:image/jpeg;base64," + imgsInfo[field[i]["field"]] : "";
            let imgurl = editData[field[i]["field"]] ? editData[field[i]["field"]] : "";
            let img = (
                <Col span={4} key={i} style={{ margin: '5px 0' }}>
                    <Image
                        onlyView={true}
                        file={path}
                        text={field[i].text}
                        url={imgurl}
                    />
                </Col>
            );
            dom.push(img);
        }
        return (<Row>{dom}</Row>);
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="车辆评估结果录入"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Form layout="vertical" >
                    {this.create2Col(fields)}
                    {this.create1Col(textareaFields)}
                    {this.createImageDom(image)}
                </Form>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
            </Modal>
        );
    }
}

const VehicleRecommendEdit = Form.create()(VehicleRecommendEditForm);

export default VehicleRecommendEdit;